export default __webpack_public_path__ + "static/media/db.38dc038e.svg";